import { appLocalStorage } from '@/mixins/appLocalStorage';

export const splashScreen = {
    data() {
        return {
            showLoader: false,
            fadeoutLoader: false
        }
    },
    mixins: [appLocalStorage],
    methods: {
        showSplashScreen: function () {
            this.showLoader = true;
            this.SetShowLoader(true);
            this.fadeoutLoader = false;
            this.SetFadeoutLoader(false);
        },
        hideSplashScreen: function () {
            this.fadeoutLoader = true;
            this.SetFadeoutLoader(true);
            this.showLoader = false;
            this.SetShowLoader(false);
        }
    }
}